// firebase.js
import { initializeApp } from "firebase/app";
import { isSupported, getMessaging, getToken, onMessage } from "firebase/messaging";
import { toast } from "react-toastify";

const firebaseConfig = {
  apiKey: "AIzaSyDHN5-B8BLt0ispYbdn8OsFT-3NzkTJK6M",
  authDomain: "qkiere-new.firebaseapp.com",
  projectId: "qkiere-new",
  storageBucket: "qkiere-new.firebasestorage.app",
  messagingSenderId: "587421949496",
  appId: "1:587421949496:web:e5fdc29404c102150b90cd",
  measurementId: "G-SLNSW6T78E",
};

const app = initializeApp(firebaseConfig);

// Lazy: solo se inicializa si el browser lo soporta
let _messaging = null;
async function getMsg() {
  if (_messaging) return _messaging;
  const supported = await isSupported();
  if (!supported) return null;
  _messaging = getMessaging(app);
  return _messaging;
}

export async function requestPermissionAndToken() {
  try {
    const msg = await getMsg();
    if (!msg) return null;

    const permission = await Notification.requestPermission();
    if (permission !== "granted") return null;

    return await getToken(msg, {
      vapidKey:
        "BAhcrrG_tswp8eV589qLdF7tLirlxXWvXf9OLcSibchtriOPOpraA7fwhWs2-TQHQSYAZ4-XEt4Yf-2o6djpWgE",
    });
  } catch (err) {
    console.error("Error obteniendo token FCM:", err);
    return null;
  }
}

export async function listenForegroundMessages() {
  const msg = await getMsg();
  if (!msg) return;
  onMessage(msg, (payload) => {
    const title = payload.notification?.title || payload.data?.title;
    const body  = payload.notification?.body  || payload.data?.body;
    toast.info(`${title}: ${body}`, { autoClose: 3000 });
  });
}
